import { render, staticRenderFns } from "./SiniestroDetail.vue?vue&type=template&id=2f53f70d&scoped=true&"
import script from "./SiniestroDetail.vue?vue&type=script&lang=js&"
export * from "./SiniestroDetail.vue?vue&type=script&lang=js&"
import style0 from "./SiniestroDetail.vue?vue&type=style&index=0&id=2f53f70d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f53f70d",
  null
  
)

export default component.exports